<script setup lang="ts">
import User from './User.vue'
import Menu from './Menu.vue'

import { useIsSp } from '@mp/hooks'
import { useRouter } from 'vue-router'
import Notice from './Notice.vue'

import { useFixedHeader } from 'vue-use-fixed-header'
import { ref } from 'vue'

const router = useRouter()
const { isNotSp, logo } = useIsSp()

const headerRef = ref<HTMLElement | null>(null)
const { styles } = useFixedHeader(headerRef)
</script>

<template>
  <header ref="headerRef" :style="styles" class="bg-[#2F3E58] sticky left-0 right-0 top-0 z-[999] text-white">
    <div class="bg-[#2F3E58] content-container flex items-center h-[64px] overflow-hidden">
      <!-- *logo -->
      <a class="text-lg cursor-pointer text-white flex items-center" @click="router.replace({ name: 'DashboardIndex' })">
        <img :src="logo" :class="isNotSp ? '' : 'h-[33px] block'" alt="">

        <template v-if="!isNotSp"><el-divider style="margin:0 16px" direction="vertical" class="opacity-30" /> 商户平台</template>
      </a>

      <!-- *menus -->
      <div id="headerMenu" class="ml-12">
        <Menu />
      </div>

      <!-- *user content -->
      <div class="ml-auto text-sm flex items-center relative">
        <Notice />
        <el-divider
          style="--el-border-color: rgba(255,255,255,0.5)"
          direction="vertical" class="mx-4!"
        />
        <User />
      </div>
    </div>
  </header>
</template>
